var React = require('react');

function PublicationsInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#0070c1;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}")),React.createElement("g",{"transform":"translate(1 1)","key":1},[React.createElement("path",{"className":"a","d":"M20.06,32.37H5a4,4,0,0,1-4-4V1H25.62V9H1","transform":"translate(-1 -1)","key":0}),React.createElement("path",{"className":"a","d":"M25.62,9H32V29.26a3.12,3.12,0,0,1-3.12,3.12h-.1a3.12,3.12,0,0,1-3.12-3.12V9Z","transform":"translate(-1 -1)","key":1}),React.createElement("line",{"className":"a","x2":"16.06","transform":"translate(0 15.78)","key":2}),React.createElement("line",{"className":"a","x2":"16.06","transform":"translate(0 23.58)","key":3})])]);
}

PublicationsInline.defaultProps = {"width":"33","height":"33.38","viewBox":"0 0 33 33.38"};

module.exports = PublicationsInline;

PublicationsInline.default = PublicationsInline;
